import { useState } from 'react';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import { updateLandlordEndpoint, createLandlordEndpoint } from '../services/landlordService';
import { LandlordUpdate } from '../models/landlordModel';

interface UpdateResult {
  status: number;
  error?: any;
  data?: any;
}

const useUpdateLandlord = () => {
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const { callEndpoint } = useCallApiAndLoad();
  const [loading, setLoading] = useState(false);

  const updateLandlord = async (
    landlordId: string | null,
    fields: LandlordUpdate
  ): Promise<UpdateResult> => {
    setLoading(true);
    try {
      let response;
      if (landlordId) {
      
        const { status, data } = await callEndpoint(
          updateLandlordEndpoint(landlordId, { phone: fields.phone }, token)
        );
        response = { status, error: status !== 200 ? data : undefined };
      } else {
        
        const registrationFields = {
          ...fields,
          first_name: (fields as any).first_name ?? '',
          last_name: (fields as any).last_name ?? '',
          area_code: (fields as any).area_code ?? '',
          phone: (fields as any).phone ?? '',
          email: (fields as any).email ?? '',
        };
        const { status, data } = await callEndpoint(
          createLandlordEndpoint(registrationFields, token)
        );
        response = { status, error: status !== 201 ? data : undefined, data };
      }
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      return { status: 500, error };
    }
  };

  return {
    updateLandlord,
    loading,
  };
};

export default useUpdateLandlord;